import _defineProperty from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
import { groupSort, max, min, sum, mean, median, sort } from 'd3-array';
import { columnOf } from './utils/helper';
function createReducer(channel, options, encode) {
  var _options$by = options.by,
    by = _options$by === void 0 ? channel : _options$by,
    _options$reducer = options.reducer,
    reducer = _options$reducer === void 0 ? 'max' : _options$reducer;
  var _columnOf = columnOf(encode, by),
    _columnOf2 = _slicedToArray(_columnOf, 1),
    V = _columnOf2[0];
  if (typeof reducer === 'function') return function (GI) {
    return reducer(GI, V);
  };
  if (reducer === 'max') return function (GI) {
    return max(GI, function (i) {
      return +V[i];
    });
  };
  if (reducer === 'min') return function (GI) {
    return min(GI, function (i) {
      return +V[i];
    });
  };
  if (reducer === 'sum') return function (GI) {
    return sum(GI, function (i) {
      return +V[i];
    });
  };
  if (reducer === 'median') return function (GI) {
    return median(GI, function (i) {
      return +V[i];
    });
  };
  if (reducer === 'mean') return function (GI) {
    return mean(GI, function (i) {
      return +V[i];
    });
  };
  if (reducer === 'first') return function (GI) {
    return V[GI[0]];
  };
  if (reducer === 'last') return function (GI) {
    return V[GI[GI.length - 1]];
  };
  throw new Error("Unknown reducer: ".concat(reducer));
}
function sortQuantitative(I, mark, options) {
  var reverse = options.reverse,
    channel = options.channel;
  var encode = mark.encode;
  var _columnOf3 = columnOf(encode, channel),
    _columnOf4 = _slicedToArray(_columnOf3, 1),
    V = _columnOf4[0];
  var sortedI = sort(I, function (i) {
    return V[i];
  });
  if (reverse) sortedI.reverse();
  // const s = typeof slice === 'number' ? [0, slice] : slice;
  return [sortedI, mark];
}
// If domain is specified, only sort data in the domain.
function filterIndex(I, values, specifiedDomain) {
  if (!Array.isArray(specifiedDomain)) return I;
  var domain = new Set(specifiedDomain);
  return I.filter(function (i) {
    return domain.has(values[i]);
  });
}
function sortOrdinal(I, mark, options) {
  var _a;
  var reverse = options.reverse,
    slice = options.slice,
    channel = options.channel,
    rest = __rest(options, ["reverse", "slice", "channel"]);
  var encode = mark.encode,
    _mark$scale = mark.scale,
    scale = _mark$scale === void 0 ? {} : _mark$scale;
  var domain = (_a = scale[channel]) === null || _a === void 0 ? void 0 : _a.domain;
  var _columnOf5 = columnOf(encode, channel),
    _columnOf6 = _slicedToArray(_columnOf5, 1),
    T = _columnOf6[0];
  var normalizeReducer = createReducer(channel, rest, encode);
  var SI = filterIndex(I, T, domain);
  var sortedDomain = groupSort(SI, normalizeReducer, function (i) {
    return T[i];
  });
  if (reverse) sortedDomain.reverse();
  var s = typeof slice === 'number' ? [0, slice] : slice;
  var slicedDomain = slice ? sortedDomain.slice.apply(sortedDomain, _toConsumableArray(s)) : sortedDomain;
  return [I, deepMix(mark, {
    scale: _defineProperty({}, channel, {
      domain: slicedDomain
    })
  })];
}
/**
 * Sort marks groups by groups.
 */
export var Sort = function Sort() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$reverse = options.reverse,
    reverse = _options$reverse === void 0 ? false : _options$reverse,
    slice = options.slice,
    channel = options.channel,
    _options$ordinal = options.ordinal,
    ordinal = _options$ordinal === void 0 ? true : _options$ordinal,
    rest = __rest(options, ["reverse", "slice", "channel", "ordinal"]);
  return function (I, mark) {
    if (!ordinal) {
      return sortQuantitative(I, mark, Object.assign({
        reverse: reverse,
        slice: slice,
        channel: channel
      }, rest));
    }
    return sortOrdinal(I, mark, Object.assign({
      reverse: reverse,
      slice: slice,
      channel: channel
    }, rest));
  };
};
Sort.props = {};